import { createDomain, sample } from 'effector'
import { createGate } from 'effector-react'
import { Promocode } from '~/shared/api/promocodes'
import { createCache } from '~/shared/lib/mapCacheFactory'
import { isString } from '~/shared/lib/utils'

export const domain = createDomain('entities.promotion')

export const Gate = createGate<{ promotionId: UniqueId }>()

export const $promotionId = domain
  .createStore<UniqueId | null>(null)
  .on(Gate.state, (_, { promotionId }) => promotionId)
  .on(Gate.close, () => null)

export const requestFx = domain.createEffect<UniqueId, Promocode>({
  handler: fetchPromotion,
})

export const savePromotionFx = domain.createEffect<Promocode, Promocode>({
  async handler(promotion) {
    await promotion.save()
    return fetchPromotion(promotion.getApiId() as UniqueId)
  },
})

sample({
  clock: $promotionId,
  filter: isString,
  target: requestFx,
})

const {
  $cache: $promotionCache,
  useCache: usePromotionCache,
  updateCache,
} = createCache<Promocode>({
  domain,
  getEntityId: (promotion) => promotion.getApiId() as UniqueId,
})
export { $promotionCache, usePromotionCache }

$promotionCache.on(
  [requestFx.doneData, savePromotionFx.doneData],
  (cache, promotion) => updateCache(cache, [promotion]),
)

export async function fetchPromotion(id: UniqueId) {
  const response = await Promocode.with('driverRegions')
    .with('carBrands')
    .with('carModels')
    .with('carRegions')
    .find(id)
  return response.getData() as Promocode
}
